import Link from "next/link";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { getProjects } from "../../utils/api";

const Explore_collection_item = ({ itemFor }) => {
  const { data, error } = getProjects();

  return (
    <>
      {data?.map((item) => {
        const { projectId, image, projectName, bid_number, eth_number, react_number } = item;
        const imageUrl = `/images/projects/${projectId}.webp`;
        const itemLink = `/collection/${projectId}`;
        
        const {
          id,
          bigImage,
          subImage1,
          subImage2,
          subImage3,
          userImage,
          title,
          itemsCount,
          userName,
        } = item;
        return (
          <article key={projectId}>
            <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
              <Link
                href={itemLink}
                className="flex space-x-[0.625rem]"
              >
                <span className="w-[74.5%]">
                  <Image
                    width={152}
                    height={242}
                    src={imageUrl}
                    alt="item 1"
                    className="h-full w-full rounded-[0.625rem] object-cover"
                    loading="lazy"
                  />
                </span>
                <span className="flex w-1/3 flex-col space-y-[0.625rem]">
                  <Image
                    width={68}
                    height={74}
                    src={imageUrl}
                    alt="item 1"
                    className="h-full w-full rounded-[0.625rem] object-cover"
                    loading="lazy"
                  />
                  <Image
                    width={68}
                    height={74}
                    src={imageUrl}
                    alt="item 1"
                    className="h-full w-full rounded-[0.625rem] object-cover"
                    loading="lazy"
                  />
                  <Image
                    width={68}
                    height={74}
                    src={imageUrl}
                    alt="item 1"
                    className="h-full w-full rounded-[0.625rem] object-cover"
                    loading="lazy"
                  />
                </span>
              </Link>

              <Link
                href={itemLink}
                className="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white"
              >
                {projectName}
              </Link>

            </div>
          </article>
        );
      })}
    </>
  );
};

export default Explore_collection_item;